<div class="names" *ngIf="validationMessage !== null">
  <ion-item class="errorContainer" lines="none">
    <ion-note class="validationMessage" color="danger" slot="start"><ion-icon name="warning"></ion-icon>{{validationMessage}}</ion-note>
  </ion-item>
</div>

